module.exports = "/packs/images/svg/facilities/prayer-room~8974b0b27c72ac2735cb646ed44c254e.svg";